<tt-page *ngIf="!!page">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <tt-input ttLabel="infotext" [ttModel]="page.infotext" ttReadonly></tt-input>
        </tt-card>

        <tt-list-legacy [listItems]="itemsListFinishedJobs" ltype="multi" [optionfunc]="clickItem.bind(this)"></tt-list-legacy>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="custactcalcjobexit_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="30">
                    <tt-card class="col-xs-12 p-5">
                        <tt-input ttLabel="infotext" [ttModel]="page.infotext" ttReadonly></tt-input>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="70">
                    <tt-list-legacy class="col-xs-12 p-5" [listItems]="itemsListFinishedJobs" ltype="multi" [optionfunc]="clickItem.bind(this)"></tt-list-legacy>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input class="col-xs-12 sp-0" tt-label="infotext" tt-model="vm.model.menu.infotext" tt-change="vm.model.menu.infotext = $value" tt-readonly="true"></tt-input>
    </tt-card>

    <im-list-directive class="col-xs-12 col-md-4 sp-0" list-items="vm.model.itemsListFinishedJobs" ltype="custom" optionfunc="vm.clickItem(item)"></im-list-directive>
</tt-page>-->
